export const ALTA_TYPES = {
  SIFE: 'SIFE',
  CARTA: 'CARTA',
  VIDEO_AGREEMENT: 'VIDEO_AGREEMENT',
};

export const OPTIONS = [
  { value: ALTA_TYPES.SIFE, text: 'Remoto' },
  { value: ALTA_TYPES.CARTA, text: 'Carta' },
  { value: ALTA_TYPES.VIDEO_AGREEMENT, text: 'Video acuerdo' },
];
